import { render, staticRenderFns } from "./SummaryExtraPeopleLine.vue?vue&type=template&id=1918a777&"
import script from "./SummaryExtraPeopleLine.vue?vue&type=script&lang=js&"
export * from "./SummaryExtraPeopleLine.vue?vue&type=script&lang=js&"
import style0 from "./SummaryExtraPeopleLine.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports